import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tooltip,
  Tr,
  useColorModeValue
} from '@chakra-ui/react';
import Card from 'components/Card/Card';
import AppConfig from "config";
import RelatoriosController from "controllers/Relatorios/RelatoriosController";
import { Fragment, useState } from 'react';
import swal from 'sweetalert2';
window.Swal = swal;
const jwtToken = localStorage.getItem('access_token');

function ResultPerguntasView() {
  const [data, setData] = useState([]);
  const [selectedReport, setSelectedReport] = useState('relatorioConsolidadoDiario');
  const [showReportDetails, setShowReportDetails] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const textColor = useColorModeValue('gray.700', 'white');

  const handleModalOpen = () => {
    setSelectedReport('relatorioConsolidadoDiario');
    setIsModalOpen(true);
    setStartDate('');
    setEndDate('');
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleSendReport = async () => {
    if (selectedReport === 'relatorioConsolidado') {
      await fetchData(startDate, endDate);
      setIsModalOpen(false);
    } else if (selectedReport === 'relatorioConsolidadoDiario') {
      await fetchDataDiario();
      setIsModalOpen(false);
    }
  };

  const fetchDataDiario = async () => {
    try {
      const response = await RelatoriosController.ListRelatorios();
      if (!response) {
        throw new Error('Network response was not ok');
      }
      setData(response);
      setShowReportDetails(true);
    } catch (error) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        }
      });
      Toast.fire({
        icon: "error",
        title: "Não há dados disponíveis."
      });
      console.error('Error fetching daily data:', error);
    }
  };
  const fetchData = async (startDate, endDate) => {
    try {
      let relatoriosResponse;
      if (selectedReport === 'relatorioConsolidado') {
        if (!startDate || !endDate) {
          relatoriosResponse = await RelatoriosController.ListRelatoriosConsolidate(null, null);
        } else {
          relatoriosResponse = await RelatoriosController.ListRelatoriosConsolidate(startDate, endDate);
        }
      } else if (selectedReport === 'relatorioConsolidadoDiario') {
        relatoriosResponse = await RelatoriosController.ListRelatorios();
      }
      if (!relatoriosResponse || relatoriosResponse.length === 0) {
        throw new Error('Relatórios response was empty');
      }
      setData(relatoriosResponse);
      setShowReportDetails(true);
    } catch (error) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        }
      });
      Toast.fire({
        icon: "error",
        title: "Não há dados disponíveis."
      });
      console.error('Error fetching data:', error);
      setData([]);
      setShowReportDetails(false);
    }
  };

  return (
    <Flex direction='column' height="100%" width="100%">
      <Card overflowX={{ sm: "scroll", xl: "hidden" }}>
        <Button onClick={handleModalOpen} colorScheme='blue' mb='20px'>
          Gerar relatório
        </Button>
        {(selectedReport === 'relatorioConsolidado' || selectedReport === 'relatorioConsolidadoDiario') && showReportDetails && data.length > 0 && (
          <Table variant='simple' color={textColor}>
            <Thead>
              <Tr color='gray.400'>
                <Th>Agendamento</Th>
                <Th>Total</Th>
                <Th>Pendente</Th>
                <Th>Processados</Th>
                <Th>Erro</Th>
                <Th>Arquivos Processados</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.map((audit) => (
                <AuditRow key={audit.id} audit={audit} selectedReport={selectedReport} startDate={startDate} endDate={endDate} />
              ))}
            </Tbody>
          </Table>
        )}
        <Modal isOpen={isModalOpen} onClose={handleModalClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Selecione o relatório</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex direction="column" mb="4">
                <Select
                  mb="4"
                  onChange={(e) => {
                    setSelectedReport(e.target.value);
                    setShowReportDetails(false);
                  }}
                >
                  <option value='relatorioConsolidadoDiario'>Relatório diário</option>
                  <option value='relatorioConsolidado'>Relatório consolidado</option>
                </Select>
                {selectedReport === 'relatorioConsolidado' && (
                  <Fragment>
                    <Flex direction="column" mb="4">
                      <label>
                        <Tooltip label="Datas vazias resultarão no Relatório Consolidado.">
                          Data Início:
                        </Tooltip>
                      </label>
                      <Input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        placeholder="Data de início"
                      />
                    </Flex>
                    <Flex direction="column" mb="4">
                      <label>
                        <Tooltip label="Datas vazias resultarão no Relatório Consolidado.">
                          Data Fim:
                        </Tooltip>
                      </label>
                      <Input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        placeholder="Data de fim"
                      />
                    </Flex>
                  </Fragment>
                )}
              </Flex>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={handleSendReport}>
                Gerar
              </Button>
              <Button variant='ghost' onClick={handleModalClose}>
                Fechar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Card>
    </Flex>
  );
}

function AuditRow({ audit, selectedReport, startDate, endDate }) {
  const [showDetails, setShowDetails] = useState(false);
  const [details, setDetails] = useState(null);

  const toggleDetails = async () => {
    setShowDetails(!showDetails);
    if (!showDetails) {
      try {
        let apiUrl;
        if (selectedReport === 'relatorioConsolidado') {
          apiUrl = AppConfig.BACKEND_URL_REFATORADO + `monitoring/results_consolidated_report?audit_name=${audit.Nome_Agendamento}&audit_id=${audit.audit_id}&start_date=${startDate}&end_date=${endDate}`;
        } else if (selectedReport === 'relatorioConsolidadoDiario') {
          apiUrl = AppConfig.BACKEND_URL_REFATORADO + `monitoring/results_daily_report?audit_name=${audit.Nome_Agendamento}&audit_id=${audit.audit_id}`;
          const today = new Date().toISOString().slice(0, 10);
          apiUrl += `&date_inserted=${today}`;
        }

        const response = await fetch(apiUrl, {
          headers: {
            'Authorization': `Bearer ${jwtToken}`
          }
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const jsonData = await response.json();

        jsonData.forEach((detail) => {
          if (detail.status === 'READY') {
            detail.status = 'PROCESSANDO';
          } else if (detail.status === 'FINISHED') {
            detail.status = 'FINALIZADO';
          }
        });

        setDetails(jsonData);
      } catch (error) {
        console.error('Error fetching details:', error);
        setDetails(null);
      }
    }
  };

  return (
    <Fragment>
      <Tr>
        <Td>{audit.Nome_Agendamento}</Td>
        <Td>{audit.Total}</Td>
        <Td>{audit.Processamentos_Pendentes}</Td>
        <Td>{audit.Processamentos_Finalizados}</Td>
        <Td>{audit.Transcricoes_com_erro}</Td>
        <Td>
          <Button onClick={() => toggleDetails(audit.audit_name)}>
            {showDetails ? "Ocultar detalhes" : "Mostrar detalhes"}
          </Button>
        </Td>
      </Tr>
      {showDetails && details && (
        <Tr>
          <Td colSpan={5}>
            <Table variant='simple'>
              <Thead>
                <Tr>
                  <Th>Nome do Arquivo</Th>
                  <Th>Data Inserida</Th>
                  <Th>Status</Th>
                </Tr>
              </Thead>
              <Tbody>
                {details.map((detail, index) => (
                  <tr key={index}>
                    <Td>{detail.recording_name}</Td>
                    <Td>{detail.date_inserted}</Td>
                    <Td>{detail.status}</Td>
                  </tr>
                ))}
              </Tbody>
            </Table>
          </Td>
        </Tr>
      )}
    </Fragment >
  );
}

export default ResultPerguntasView;